/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Restart and load new model</h4>

<p>Discard current model and load a new one.</p>`;

export default function RefreshTooltip() {
    return h('div', { innerHTML: body });
}
